import { Component, OnInit, inject } from '@angular/core';
import { Router } from '@angular/router';
import { CompanyDto, CompanyControllerService, InfoBoxCheckDto } from 'src/app/api-client';
import { TokenService } from 'src/app/shared/services/token.service';

@Component({
  selector: 'app-backoffice-info',
  templateUrl: './backoffice-info.component.html',
  styleUrls: ['./backoffice-info.component.scss']
})
export class BackofficeInfoComponent implements OnInit {
  private _token = inject(TokenService);
  private _company = inject(CompanyControllerService);
  public router = inject(Router);

  public isProdVersion: boolean = false;
  public showInfo: boolean = false;
  public status: CompanyDto.LoyaltyProgramStatusEnum = CompanyDto.LoyaltyProgramStatusEnum.Invalid;
  public infoType: 'config' | 'waitingList' = null;
  public onWaitingList: boolean = false;

  ngOnInit(): void {
    this.checkForInfoBox();
  }

  private checkForInfoBox(): void {
    this._company.checkForInfoBox().subscribe({
      next: (response: InfoBoxCheckDto) => {
        this.isProdVersion = response.fullVersion;
        this.onWaitingList = response.onWaitingList;
        this.status = response.loyaltyProgramStatus;
        this.checkCompanyStatus();
      },
      error: () => {
        // If there's an error, proceed with the existing data
        this.checkCompanyStatus();
      }
    });
  }

  private checkCompanyStatus(): void {
    // Check if loyaltyConfigStatus is IN_PROGRESS or INVALID
    if (
      this.status === CompanyDto.LoyaltyProgramStatusEnum.InProgress ||
      this.status === CompanyDto.LoyaltyProgramStatusEnum.Invalid
    ) {
      this.showInfo = true;
      this.infoType = 'config';
    }
    // The trial-version notice and the "upgrade request submitted / awaiting
    // approval" state now live in the dashboard getting-started checklist
    // (the 'fullVersion' onboarding step), so neither is surfaced here.
    else {
      this.showInfo = false;
    }
  }

  public closeInfo(): void {
    this.showInfo = false;
  }
}
